const defaultCorsProxies = [
    {
      id: "/.netlify/functions/node-fetch?url=",
      checked: true,
    },
  ];
  export default defaultCorsProxies;